import type { MediaAssetServiceResponse } from '@shared-types/mediaAssets.types';
import { splitArray } from '@utilities/collection-utils';
import { loadFromAPIs } from '@utilities/fetch';
import { apiKey, masApiUrl } from '@utilities/WindowContext';

const arrayMaxSize = 20;
export const fetchMediaAssets = (videoIds: string[], signal?: AbortSignal) =>
  Promise.all(
    splitArray(videoIds, arrayMaxSize)
      .map((ids) => ({ mediaAssetIds: ids }))
      .map((params) =>
        loadFromAPIs<MediaAssetServiceResponse[]>('v1/access-rights', params, {
          apiKey,
          apiUrl: masApiUrl,
          signal,
        }),
      ),
  ).then((responses) => responses.flat());
